export const GET_PRICE_ROUTE = 'GET_PRICE_ROUTE';
export const GET_PRICE_ROUTE_LOADING = 'GET_PRICE_ROUTE_LOADING';
export const GET_PRICE_ROUTE_SUCCESS = 'GET_PRICE_ROUTE_SUCCESS';
export const GET_PRICE_ROUTE_ERROR = 'GET_PRICE_ROUTE_ERROR';

export const GET_TOKEN_LIST = 'GET_TOKEN_LIST';
export const GET_TOKEN_LIST_LOADING = 'GET_TOKEN_LIST_LOADING';
export const GET_TOKEN_LIST_SUCCESS = 'GET_TOKEN_LIST_SUCCESS';
export const GET_TOKEN_LIST_ERROR = 'GET_TOKEN_LIST_ERROR';

export const SET_TOKEN_LIST = 'SET_TOKEN_LIST';
export const SET_TOKEN_LIST_LOADING = 'SET_TOKEN_LIST_LOADING';
export const SET_TOKEN_LIST_SUCCESS = 'SET_TOKEN_LIST_SUCCESS';
export const SET_TOKEN_LIST_ERROR = 'SET_TOKEN_LIST_ERROR';

export const SET_ACCOUNT_ADDRESS = 'SET_ACCOUNT_ADDRESS';

// export const SET_NETWORK_DETAILS = 'SET_NETWORK_DETAILS';
